import { theme } from '@/styles/theme';
import { CSSProperties, PropsWithChildren } from 'react';

type SecaoHomeMobileProps = PropsWithChildren<{
  style?: CSSProperties;
}>;

export const PrimeiraSecaoHomeMobile = ({
  children,
  style = {},
}: SecaoHomeMobileProps) => (
  <section
    style={{
      display: 'flex',
      flexDirection: 'column',
      marginTop: theme.spacing[5],
      marginBottom: theme.spacing[3],
      padding: `0 ${theme.spacing[4]}px`,
      gap: theme.spacing[6],
      ...style,
    }}
  >
    {children}
  </section>
);

export const SegundaSecaoHomeMobile = ({
  children,
  style = {},
}: SecaoHomeMobileProps) => (
  <section
    style={{
      marginTop: theme.spacing[6] + theme.spacing[1],
      marginBottom: theme.spacing[6],
      ...style,
    }}
  >
    {children}
  </section>
);

export const UltimaSecaoHomeMobile = ({
  children,
  style = {},
}: SecaoHomeMobileProps) => (
  <section
    style={{
      display: 'flex',
      flexDirection: 'column',
      padding: `0 ${theme.spacing[4]}px`,
      gap: theme.spacing[6],
      ...style,
    }}
  >
    {children}
  </section>
);
